/* js/remember-article.js */

;(function ($, window, document) {

    $(document).ready(function ($) {

        if (typeof openRemeberList === 'function') {
            openRemeberList();
        }

        function openRemeberList() {

            var $trigger = $('.remember-article--list-open'),
                $link = $('.remember-article--list-open a'),
                openCls = 'is--open';

            $link.on('click', function (e) {
                e.preventDefault();
            });

            $trigger.on('click', function () {

                var $me = $(this),
                    $target = $('.remember-article--list-container');


                if ($target.hasClass(openCls)) {
                    hideRememberedList($me, openCls, $target);
                    closeOverlay();
                } else {
                    showRememberedList($me, openCls, $target);
                    openOverlay();
                }

            });

        }

        function hideRememberedList($me, openCls, $target) {

            var $button = $('.remember-article--list-save');

            $me.removeClass(openCls);
            $target.removeClass(openCls);
            $button.removeClass(openCls);

        }

        function showRememberedList($me, openCls, $target) {

            var $button = $('.remember-article--list-save');

            $target.addClass(openCls);
            $button.addClass(openCls);
            $me.addClass(openCls);

        }

        function openOverlay() {

            var $overlay = $('.maw-overlay'),
                activeCls = 'is--active';

            $overlay.addClass(activeCls);
        }

        function closeOverlay() {

            var $overlay = $('.maw-overlay'),
                activeCls = 'is--active';

            $overlay.removeClass(activeCls);
        }

        if (typeof initOverlay === 'function') {
            initOverlay();
        }

        function initOverlay() {
            var $overlay = $('.maw-overlay'),
                activeCls = 'is--active',
                openCls = 'is--open',
                $me = $('.remember-article--list-open'),
                $target = $('.remember-article--list-container');

            $overlay.on('click', function () {
                if ($(this).hasClass(activeCls)) {
                    closeOverlay();
                    hideRememberedList($me, openCls, $target);
                } else {

                }
            });
        }

        if (typeof hideParent === 'function') {
            hideParent();
        }

        function hideParent() {
            var $trigger = $('.close--parent');

            $trigger.on('click', function () {

                var $target = $(this).parent();

                $target.fadeOut();

            });
        }

        if (typeof handlePdfButton === 'function') {
            handlePdfButton();
        }

        function handlePdfButton() {
            var $pdfDownloadButton = $('.remember-article--list-save a');

            $pdfDownloadButton.on('click', function (e) {
                e.preventDefault();
                sessionStorage.setItem("pdfDownloaded", "true");
                removeAllItems();

                var elements = $('.remember-article--list .video-product--item');
                var idList = '';
                for (var i = 0; i < elements.length; i++) {
                    var element = $(elements[i]);
                    if (i != 0) {
                        idList += ',';
                    }

                    var dataSid = element.data('sid');
                    if (typeof dataSid !== 'undefined') {
                        idList += dataSid;
                    }
                }

                var newurl = window.location.protocol
                    + "//"
                    + window.location.host
                    + window.location.pathname
                    + '?pdf=print'
                    + '&sid=' + idList

                window.location.href = newurl;
            });
        }

        if (typeof rememberArticle === 'function') {
            rememberArticle();
        }

        function removeAllItems() {
            var $item = $('.remember-article--list .video-product--item');
        }

        /**
         * This function handles the article remember function
         */

        function rememberArticle() {

            /** This function handles the remember trigger states */
            rememberArticleTrigger();

            function rememberArticleTrigger() {
                var $trigger = $('.remember-article--trigger'),
                    rememberedCls = 'is--remembered',
                    rememberAttr = 'data-remembered';

                $trigger.on('click', function () {

                    var $productItem = $(this).parents().eq(1);

                    if ($productItem.hasClass(rememberedCls)) {
                        $productItem.removeClass(rememberedCls);
                        $productItem.attr(rememberAttr, false);
                    } else {
                        $productItem.addClass(rememberedCls);
                        $productItem.attr(rememberAttr, 'true');
                    }

                    rememberArticleList($productItem, rememberAttr);

                });
            }

            function rememberArticleList($productItem, rememberAttr) {

                var isRemembered = $productItem.attr(rememberAttr);

                if (isRemembered == 'true') {
                    insertRememberedArticle($productItem);
                } else {
                    removeRememberedArticle($productItem);
                }
            }

            function insertRememberedArticle($productItem) {

                var $itemHTML = $productItem[0].outerHTML,
                    $brand = $productItem.attr('data-brand'),
                    $rememberedList = $('.remember-article--list-brand[data-brand="' + $brand + '"]');

                $rememberedList.append($itemHTML);

                removeInsideRemberedList();

            }

            function removeRememberedArticle($productItem) {
                var articleNumberAttr = 'data-artnr',
                    $rememberedList = $('.remember-article--list'),
                    uniqueIdentifier = $productItem.attr(articleNumberAttr);

                $rememberedList.find('*[data-artnr="' + uniqueIdentifier + '"]').fadeOut();
                $rememberedList.find('*[data-artnr="' + uniqueIdentifier + '"]').remove();
            }

        }

        storeRememberedList();

        function storeRememberedList() {

            if ($('.remember-article--list').length) {

                var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

                // select the target node
                var target = document.querySelector('.remember-article--list');

                var observer = new MutationObserver(function (mutations) {
                    var storeRememberedList = $('.remember-article--list').html();

                    handleBrandDivider();
                    countRememberItems();
                    localStorage.setItem("storeRememberedList", storeRememberedList);
                });

                observer.observe(target, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                    characterData: true
                });
            }
        }

        function handleBrandDivider() {

            var $brandLists = $('.remember-article--list-brand'),
                $product = $('.video-product--item'),
                $brandDivider = $('.remember-article--list-brand-divider'),
                activeCls = 'is--active';

            $brandLists.each(function () {
                var $target = $(this).find($product).parent().siblings($brandDivider);

                if ($(this).find($product).length) {
                    $target.addClass(activeCls);
                } else {
                    $(this).siblings($brandDivider).removeClass(activeCls);
                }
            });


        }

        if (localStorage.getItem("storeRememberedList") != null) {
            retrieveRememberedList();
        }

        function retrieveRememberedList() {

            var retrievedRememberedList = localStorage.getItem("storeRememberedList"),
                $rememberedList = $('.remember-article--list');

            $rememberedList.empty();
            $rememberedList.append(retrievedRememberedList);

        }

    });

    function removeInsideRemberedList() {

        var $trigger = $('.remember-article--list .remember-article--trigger');

        $trigger.on('click', function () {

            var $productItem = $(this).parents().eq(1),
                articleNumberAttr = 'data-artnr',
                $videoProductList = $('.video--products'),
                rememberedCls = 'is--remembered',
                uniqueIdentifier = $productItem.attr(articleNumberAttr);

            $productItem.fadeOut(300, function () {
                $productItem.remove();
            });
            $videoProductList.find('*[data-artnr="' + uniqueIdentifier + '"]').removeClass(rememberedCls);

        });

    }

    function syncLists() {
        var $rememberedListItems = $('.remember-article--list .video-product--item');

        $rememberedListItems.each(function (index) {

            var articleNumberAttr = 'data-artnr',
                uniqueIdentifier = $(this).attr(articleNumberAttr),
                $videoProductList = $('.video--products'),
                rememberedCls = 'is--remembered';

            $videoProductList.find('*[data-artnr="' + uniqueIdentifier + '"]').addClass(rememberedCls);

        });
    }

    function countRememberItems() {

        var $itemsCount = $('.remember-article--list .video-product--item').length,
            $counter = $('.remember-article--list-counter');

        $counter.empty();
        $counter.append($itemsCount);

        if ($itemsCount <= 0) {
            $counter.css('display', 'none');
        } else {
            $counter.css('display', 'flex');
        }

    }

    $(window).on('load', function () {
        initMutationObserver();
        removeInsideRemberedList();
        syncLists();
        countRememberItems();
    });

    function initMutationObserver() {


    }

})(jQuery, window, document);
